module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("\n    Дом " + _vm._s(_vm.building.number) + "\n    "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'building-edit',
        params: {
          building_id: _vm.building.id
        }
      }
    }
  }, [_vm._v("Редактировать дом")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'address-details',
        params: {
          address_id: _vm.$route.params.address_id
        }
      }
    }
  }, [_vm._v("← Назад к Домам")])], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Полный адрес")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.building.full_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Префиксы номеров контрактов")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.building.contract_number_prefixes) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Номер дома")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.building.number))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-view', {
    attrs: {
      "building-id": _vm.building.id
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27c86b25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/building/BuildingDetails.vue
// module id = 607
// module chunks = 0